import { gameState, config } from '@js/state';

let rewardBegin = false;

export default class EndScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'EndScene',
    });
  }

  preload() {}

  create() {
    this.time.delayedCall(
      1200,
      () => {
        this.spotlight = this.add.sprite(
          config.width / 2,
          config.height / 2,
          'spotlight',
        );
        this.anims.create({
          key: 'spotlightOpen',
          frames: this.anims.generateFrameNames('spotlight', {
            start: 0,
            end: 188,
            zeroPad: 0,
            prefix: 'spotlight0',
            suffix: '.png',
          }),
          frameRate: 20,
          repeat: 0,
        });

        this.anims.create({
          key: 'spotlightClose',
          frames: this.anims.generateFrameNames('spotlight', {
            start: 189,
            end: 214,
            zeroPad: 0,
            prefix: 'spotlight0',
            suffix: '.png',
          }),
          frameRate: 20,
          repeat: 0,
        });

        this.endConfetti = this.add.sprite(
          config.width / 2,
          config.height / 2,
          'endConfetti',
        );
        this.anims.create({
          key: 'endConfetti',
          frames: this.anims.generateFrameNames('endConfetti', {
            start: 0,
            end: 120,
            zeroPad: 0,
            prefix: 'seq_0_',
            suffix: '.png',
          }),
          frameRate: 40,
          repeat: 0,
        });

        this.time.delayedCall(
          2000,
          function () {
            this.spotlight.play('spotlightOpen');
          },
          [],
          this,
        );

        this.gameOver = this.add
          .sprite(config.width / 2, config.height / 2, 'youWon')
          .setAlpha(0);
        this.tweens.add({
          targets: this.gameOver,
          ease: 'Expo.easeInOut',
          duration: 1000,
          delay: 300,
          alpha: {
            getStart: () => 0,
            getEnd: () => 1,
          },
          yoyo: false,
          loop: 0,
        });

        this.tweens.add({
          targets: [this.gameOver],
          ease: 'Linear',
          duration: 300,
          delay: 3000,
          y: {
            getStart: () => config.height / 2,
            getEnd: () => config.height / 2 - 50,
          },
          yoyo: false,
          loop: 0,
        });

        this.nextButton = this.add
          .sprite(config.width / 2, 740, 'nextButton')
          .setAlpha(0)
          .setInteractive({ cursor: 'pointer' });

        this.iconDisplay1 = this.add
          .sprite(config.width / 2 - 80, config.height / 2 + 100, 'incorrectIcon')
          .setAlpha(0);
        this.iconDisplay2 = this.add
          .sprite(config.width / 2 - 80, config.height / 2 + 100, 'correctIcon')
          .setAlpha(0);

        if (gameState.win == false) {
          this.nextButton.setTexture('retryButton');
          this.gameOver.setTexture('gameOver');
          this.nextButton.on(
            'pointerover',
            function () {
              this.nextButton.setTexture('retryBlack');
            },
            this,
          );

          this.nextButton.on(
            'pointerout',
            function () {
              this.nextButton.setTexture('retryButton');
            },
            this,
          );
          // this.iconDisplay.setTexture("incorrectIcon");
          this.retryText = this.add
            .text(
              config.width / 2 - 140,
              config.height / 2 + 200,
              `Solve atleast 6 problems correctly \n to clear the game`,
              {
                fontFamily: 'font1',
                fontSize: '18px',
                fill: '#ffffff',
              },
            )
            .setAlign('center')
            .setAlpha(0);
          this.tweens.add({
            targets: [this.retryText],
            ease: 'Linear',
            duration: 300,
            delay: 3000,
            alpha: {
              getStart: () => 0,
              getEnd: () => 1,
            },
            y: {
              getStart: () => config.height / 2 + 200,
              getEnd: () => config.height / 2 + 150,
            },
            yoyo: false,
            loop: 0,
          });
        } else {
          this.endConfetti.play('endConfetti');
          this.nextButton.setTexture('nextButton');
          this.nextButton.on(
            'pointerover',
            function () {
              this.nextButton.setTexture('nextBlack');
            },
            this,
          );

          this.nextButton.on(
            'pointerout',
            function () {
              this.nextButton.setTexture('nextButton');
            },
            this,
          );
        }

        this.finalScore = this.add
          .text(
            config.width / 2 - 140,
            config.height / 2 + 140,
            `${gameState.attempted - gameState.score}/${gameState.attempted} Problems`,
            {
              fontFamily: 'font1',
              fontSize: '18px',
              fill: '#ffffff',
            },
          )
          .setAlpha(0);

        this.finalScore2 = this.add
          .text(
            config.width / 2 - 140,
            config.height / 2 + 140,
            `${gameState.score}/${gameState.attempted} Problems`,
            {
              fontFamily: 'font1',
              fontSize: '18px',
              fill: '#ffffff',
            },
          )
          .setAlpha(0);

        this.hintsUsed = this.add
          .text(
            config.width / 2 + 30,
            config.height / 2 + 140,
            `${gameState.hintUsed} Hints Used`,
            {
              fontFamily: 'font1',
              fontSize: '18px',
              fill: '#ffffff',
            },
          )
          .setAlpha(0);

        this.hintDisplay = this.add
          .sprite(config.width / 2 + 80, config.height / 2 + 100, 'hintIcon')
          .setAlpha(0)
          .setScale(1);
        if (gameState.win == false) {
          this.tweens.add({
            targets: [this.iconDisplay1, this.hintDisplay],
            ease: 'Linear',
            duration: 300,
            delay: 3000,
            y: {
              getStart: () => config.height / 2 + 100,
              getEnd: () => config.height / 2 + 50,
            },
            alpha: {
              getStart: () => 0,
              getEnd: () => 1,
            },
            yoyo: false,
            loop: 0,
          });

          this.tweens.add({
            targets: [this.finalScore, this.hintsUsed],
            ease: 'Linear',
            duration: 300,
            delay: 3000,
            alpha: {
              getStart: () => 0,
              getEnd: () => 1,
            },
            y: {
              getStart: () => config.height / 2 + 140,
              getEnd: () => config.height / 2 + 100,
            },
            yoyo: false,
            loop: 0,
          });
        }

        if (gameState.win == true) {
          this.tweens.add({
            targets: [this.iconDisplay2, this.hintDisplay],
            ease: 'Linear',
            duration: 300,
            delay: 3000,
            y: {
              getStart: () => config.height / 2 + 100,
              getEnd: () => config.height / 2 + 50,
            },
            alpha: {
              getStart: () => 0,
              getEnd: () => 1,
            },
            yoyo: false,
            loop: 0,
          });

          this.tweens.add({
            targets: [this.finalScore2, this.hintsUsed],
            ease: 'Linear',
            duration: 300,
            delay: 3000,
            alpha: {
              getStart: () => 0,
              getEnd: () => 1,
            },
            y: {
              getStart: () => config.height / 2 + 140,
              getEnd: () => config.height / 2 + 100,
            },
            yoyo: false,
            loop: 0,
          });
        }

        this.tweens.add({
          targets: [this.nextButton],
          ease: 'Linear',
          duration: 300,
          delay: 3000,
          alpha: {
            getStart: () => 0,
            getEnd: () => 1,
          },
          y: {
            getStart: () => 740,
            getEnd: () => 650,
          },
          yoyo: false,
          loop: 0,
        });

        //this.reward = this.add.sprite(config.width / 2, config.height / 2, "rewardAnim").setScale(0.45);

        /* this.anims.create({
      key: "rewardShow",
      frames: this.anims.generateFrameNames("rewardAnim", {
        start: 0,
        end: 74,
        zeroPad: 0,
        prefix: "compass",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });
    this.anims.create({
      key: "rewardLoop",
      frames: this.anims.generateFrameNames("rewardAnim", {
        start: 75,
        end: 155,
        zeroPad: 0,
        prefix: "compass",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });*/

        this.okayButton = this.add
          .sprite(config.width / 2, 740, 'okayButton')
          .setAlpha(0)
          .setInteractive({ cursor: 'pointer' });

        this.nextButton.on('pointerup', () => {
          if (gameState.win == false) {
            this.nextButton.setTexture('retryButton');

            gameState.attempted = 0;
            gameState.score = 0;
            gameState.lastButton = 0;
            gameState.lastButtonName = '';
            gameState.bulbs = 0;
            gameState.beedY = 0;
            gameState.floorNo = 0;
            gameState.gameWin = false;

            this.cameras.main.fadeOut(500, 255, 255, 255);

            this.cameras.main.once(
              'camerafadeoutcomplete',
              function () {
                this.scene.stop('EndScene');
                this.scene.start('StartScene');
              },
              this,
            );
          } else {
            this.tweens.add({
              targets: [
                this.gameOver,
                this.iconDisplay1,
                this.iconDisplay2,
                this.finalScore,
                this.finalScore2,
                this.nextButton,
                this.hintDisplay,
                this.hintsUsed,
              ],
              alpha: 0,
              duration: 300,
            });

            //  this.spotlight.play("spotlightClose");

            // this.spotlight.on(
            //  Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + "spotlightClose",
            //   this.spotlight.play("spotlightOpen");
            this.time.delayedCall(
              500,
              () => {
                //this.reward.play("rewardShow");
                rewardBegin = true;
                const midHeight = config.height / 2;
                const midWidth = config.width / 2;
                this.yOffset = 100; // this value ensure the

                /*
    A-----B-----C
    Glitter will move from A to B to C.(ie, glitter passing through 3 points)
    A is (fromx,fromy)
    B is (tox,toy)
    C is (endx,endy)

    if you are having only having just a line like A-----B
    add (endx,endy) values same as (fromx,fromy)
    */

                //>> change below values, center align the reward on figma, draw three lines according to where the gliter should move, take the cordinates.
                /*this.fromx = 649.7;
    this.fromy = 301.6 - this.yOffset;
    this.tox = 742.7;
    this.toy = 232.6 - this.yOffset;
    this.endx = 711.5;
    this.endy = 343.8 - this.yOffset;*/

                this.adjustValue = 20;
                this.fromx = 628.45 - this.adjustValue;
                this.fromy = 387 - this.yOffset;
                this.tox = 646.01 - this.adjustValue;
                this.toy = 319 - this.yOffset;
                this.endx = 628.45 - this.adjustValue;
                this.endy = 387 - this.yOffset;

                this.rewardAppearDelay = 1300; //how much delay is there from the scene start and the reward starting to appear from bottom
                this.rewardMotionDuration = 1350; //time taken for one top to bottom movement of reward

                //>> remove setTint  add bg accordingly
                //  this.add.sprite(midWidth, midHeight, "startBackground").setTint(0x000);

                this.baseCircle = this.add
                  .sprite(midWidth, midHeight - 15, 'baseCircle')
                  .setOrigin(0.5)
                  .setVisible(true)
                  .setScale(0.4);
                this.rewardLight = this.add
                  .sprite(midWidth, midHeight - 15, 'baseCircle')
                  .setOrigin(0.5)
                  .setVisible(true)
                  .setScale(0.4);

                this.compass = this.add
                  .sprite(midWidth, midHeight + 100, 'compass')
                  .setOrigin(0.5)
                  .setVisible(false)
                  .setScale(0.5);
                this.glitter = this.add
                  .sprite(midWidth + 30, midHeight - 65, 'glitter')
                  .setOrigin(0.5)
                  .setVisible(false)
                  .setScale(0.8); // +30, -65 is added to offset position of spritesheet

                this.graphics = this.add.graphics();
                this.path = { t: 0, vec: new Phaser.Math.Vector2() };
                /*we defined a path, t=0 means, initial point in path, t=1 means end of path
    the movement of glitter is done by tweening the value of t form 0 to 1, such that it moves from intital point to end.
    vec: a new vector is created as a place holder.
    */

                // this.curve is a phaser.curve path, with goes through point A->B->C
                this.curve = new Phaser.Curves.Path(this.fromx, this.fromy);
                this.curve.lineTo(this.tox, this.toy);
                this.curve.lineTo(this.endx, this.endy);

                //here t is tweened from 0->1 | on this.path
                this.tweens.add({
                  targets: this.path,
                  t: 1,
                  ease: 'Sine.easeInOut',
                  duration: 5400,
                  yoyo: true,
                  repeat: -1,
                });

                // reward is setvisible and the appearing of reward is done after rewardAppearDelay

                this.time.delayedCall(
                  this.rewardAppearDelay,
                  () => {
                    this.compass.setVisible(true);
                  },
                  [],
                  this,
                );

                this.tweens.add({
                  targets: this.compass,
                  // x: midWidth,
                  y: midHeight - this.yOffset,
                  //angle:0,
                  scale: 1,
                  delay: this.rewardAppearDelay,
                  ease: 'Linear',
                  duration: 1000,
                  yoyo: false,
                  repeat: 0,
                  completeDelay: 0,
                  onComplete: () => {
                    this.glitter.setVisible(true);
                    this.glitter.play('showglitter');
                    /*
        console.log(curve) to understand what all parameters are there (fyi only)

        A is this.curve.startPoint
        B is this.curve.curves[0] | this.curve.curves[0].p0 stores x cordinate, this.curve.curves[0].p1 stores y cordinate.
        C is this.curve.curves[1] | this.curve.curves[1].p0 stores x cordinate, this.curve.curves[1].p1 stores y cordinate.
        */

                    this.tweens.add({
                      targets: [this.curve.startPoint, this.curve.curves[0].p0],
                      y: this.fromy + 70,
                      ease: 'Sine.easeInOut',
                      duration: this.rewardMotionDuration,
                      yoyo: true,
                      repeat: -1,
                    });

                    this.tweens.add({
                      targets: [this.curve.curves[0].p1, this.curve.curves[1].p0],
                      y: this.toy + 70,
                      ease: 'Sine.easeInOut',
                      duration: this.rewardMotionDuration,
                      yoyo: true,
                      repeat: -1,
                    });

                    this.tweens.add({
                      targets: this.curve.curves[1].p1,
                      y: this.endy + 70,
                      ease: 'Sine.easeInOut',
                      duration: this.rewardMotionDuration,
                      yoyo: true,
                      repeat: -1,
                    });

                    this.tweens.add({
                      targets: this.compass,
                      y: {
                        from: midHeight - this.yOffset,
                        to: midHeight + 70 - this.yOffset,
                      },
                      ease: 'Sine.easeInOut',
                      duration: this.rewardMotionDuration,
                      yoyo: true,
                      repeat: -1,
                    });
                  },
                });

                this.anims.create({
                  key: 'showglitter',
                  frames: this.anims.generateFrameNames('glitter', {
                    start: 0,
                    end: 32,
                    zeroPad: 0,
                    prefix: 'glitterAnim',
                    suffix: '.png',
                  }),
                  frameRate: 15,
                  repeat: -1,
                });

                this.anims.create({
                  key: 'circleopen',
                  frames: this.anims.generateFrameNames('baseCircle', {
                    start: 0,
                    end: 74,
                    zeroPad: 0,
                    prefix: 'baseCircleAnim',
                    suffix: '.png',
                  }),
                  frameRate: 30,
                  repeat: 0,
                });

                this.anims.create({
                  key: 'rewardopen',
                  frames: this.anims.generateFrameNames('rewardLight', {
                    start: 0,
                    end: 155,
                    zeroPad: 0,
                    prefix: 'rewardLightAnim',
                    suffix: '.png',
                  }),
                  frameRate: 30,
                  repeat: 0,
                });

                this.anims.create({
                  key: 'circleglitterloop',
                  frames: this.anims.generateFrameNames('baseCircle', {
                    start: 74,
                    end: 155,
                    zeroPad: 0,
                    prefix: 'baseCircleAnim',
                    suffix: '.png',
                  }),
                  frameRate: 30,
                  repeat: -1,
                });

                this.baseCircle.play('circleopen').once('animationcomplete', () => {
                  this.baseCircle.play('circleglitterloop');
                });

                this.rewardLight.play('rewardopen');

                this.tweens.add({
                  targets: this.okayButton,
                  ease: 'Linear',
                  duration: 300,
                  delay: 3000,
                  alpha: 1,
                  y: 650,
                });

                this.add.sprite(577, 126, 'rewardEarned').setOrigin(0);
                this.add.sprite(535, 570, 'rewardName').setOrigin(0);
              },
              this,
            );
            // }, this
            // );
          }
        });
        this.okayButton.on(
          'pointerover',
          function () {
            this.okayButton.setTexture('okayBlack');
          },
          this,
        );

        this.okayButton.on(
          'pointerout',
          function () {
            this.okayButton.setTexture('okayButton');
          },
          this,
        );

        this.okayButton.on(
          'pointerup',
          () => {
            this.okayButton.setTexture('okayDisabled');
          },
          this,
        );
      },
      [],
      this,
    );
  }

  update() {
    if (rewardBegin == true) {
      this.graphics.clear();

      //show the movement path of glitter
      // this.graphics.lineStyle(5, 0xffffff, 1);
      // this.curve.draw(this.graphics);

      //below lines get executed continuously, such that glitter position will change
      this.curve.getPoint(this.path.t, this.path.vec); //this.curve is the route in which we need glitter to move, getpoint() will calculate the vector location according to tween of "t" and stored on vec
      this.glitter.setPosition(this.path.vec.x, this.path.vec.y); //from vec
    }
  }
}
